import MUIAdd from '@mui/icons-material/Add'

export const Add = MUIAdd
